import { useCallback, useMemo, useState } from "react";
import { useLocation } from "react-router";
import { usePageLoader } from "../../../../common/contexts/page_content_context";
import { useBackOrNavigate } from "../../../../common/utils/navigateUtils";
import { useDependencyInjection } from "../../../../config/di/dependency_injection_context";
import { usePageStartBootstrap } from "../../../../common/hooks/use_page_start_bootstrap";
import { processError } from "../../../../common/utils/base_error";
import { uploadFileToBase64StringValid } from "../../../../common/utils/utils";
import { LogTipoTabela } from "../../../../common/utils/log_tabela_tipo";
import { useChangeHistory } from "../../../../common/hooks/use_change_history";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { defaultEntregaObraClienteChecklistCadastroForm, EntregaObraClienteChecklistCadastroForm, EntregaObraClienteChecklistCadastroSchema } from "../schemas/entrega_obra_cliente_verificacao/entregaObraClienteChecklistCadastro";
import { DropDown } from "../../../../common/domain/models/dropdown";
import { EntregaObraClienteChecklist } from "../../domain/models/entrega_obra_cliente_checklist";
import { InformacoesEntregaObraClienteModel } from "../../domain/models/informacoes_entrega_obra_cliente";
import { EntregaObraClienteArquivoAuxModel } from "../../domain/models/entrega_obra_cliente_arquivo_aux";
import { EntregaObraClienteTermoModel } from "../../domain/models/entrega_obra_cliente_termo";
import { VerificacaoChecklistModel } from "../../domain/models/verificacao_checklist";
import { EntregaObraClienteOcorrenciaForm } from "../schemas/entrega_obra_cliente_verificacao/entrega_obra_cliente_ocorrencia";
import { EntregaObraClienteTermoForm } from "../schemas/entrega_obra_cliente_verificacao/entregaObraClienteTermoCadastro";
import { EntregaObraClienteArquivoAuxForm } from "../schemas/entrega_obra_cliente_verificacao/entregaObraClienteArquivoAuxCadastro";
import { EntregaObraPesquisaSatisfacaoLista } from "../../domain/models/entrega_obra_pesquisa_satisfacao_lista";
import { EntregaObraPesquisaSatisfacao } from "../../domain/models/entrega_obra_pesquisa_satisfacao";
import { PesquisaSatisfacaoForm } from "../schemas/AssistenciaTecnica_cadastro/pesquisa_satisfacao";
import { EntregaPesquisaSatisfacaoForm } from "../schemas/entrega_obra_cliente_verificacao/entrega_pesquisa_satisfacacao";
import { useReportViewer } from "../../../../config/hooks/utils/report_viewer";

/**
 * useEntregaObrasClienteVerificacaoViewModel
 */

export const useEntregaObrasClienteVerificacaoViewModel = () => {
    const location = useLocation();
    // const { idUsuario } = useUserAuthStore();

    const {
        commons: {
            getAllLogAlteracaoByParentUseCase,
            getAllLogAlteracaoUseCase,
            getTermosDropDownUseCase,

        },
        reports: {
            getReportEntregaObraClienteSimplesUseCase,
            getReportEntregaObraClienteTermoUseCase
        },
        entregaObras: {
            getInformacoesEntregaObraClienteByIdUseCase,
            getEntregaObrasClienteByIdUseCase,
            updateEntregaObrasClienteChecklistUseCase,
            getAllVerificacaoChecklistListaUseCase,
            getAllEntregaObraClienteArquivoAuxUseCase,
            getEntregaObraClienteArquivoAuxByIdUseCase,
            getAllEntregaObraClienteTermoUseCase,
            getAllInformacoesEntregaObraClienteUseCase,
            createInformacoesEntregaObraClienteUseCase,
            createEntregaObraClienteArquivoAuxUseCase,
            createEntregaObraClienteTermoUseCase,
            updateInformacoesEntregaObraClienteUseCase,
            updateEntregaObraClienteArquivoAuxUseCase,
            deleteEntregaObraClienteArquivoAuxUseCase,
            deleteInformacoesEntregaObraClienteUseCase,
            deleteEntregaObraClienteTermoUseCase,
            getPesquisaSatisfacaoDropDownUseCase,
            createEntregaPesquisaSatisfacaoUseCase,
            getAllEntregaPesquisaSatisfacaoUseCase,
            getEntregaPesquisaSatisfacaoByIdUseCase,
            updateEntregaPesquisaSatisfacaoUseCase,
            deleteEntregaPesquisaSatisfacaoUseCase,
            downloadEntregaObraClienteArquivoAuxByIdUseCase,
            downloadInfoEntregaObraClienteArquivoByIdUseCase
        },
    } = useDependencyInjection();

    const {
        pushInfoNotification,
        pushErrorNotification,
        pushWarnNotification,
        setPageSaving,
        setCustomLoading,
    } = usePageLoader();

    const backOrNavigate = useBackOrNavigate();

    const hookForm = useForm<EntregaObraClienteChecklistCadastroForm>({
        mode: 'onSubmit',
        reValidateMode: 'onSubmit',
        defaultValues: defaultEntregaObraClienteChecklistCadastroForm,
        resolver: zodResolver(EntregaObraClienteChecklistCadastroSchema),
    });

    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string>();

    const [ddlTermos, setDdlTermos] = useState<DropDown[]>();
    const [ddlPesquisaSatisfacao, setDdlPesquisaSatisfacao] = useState<DropDown[]>();

    const [selectedIdEntregaObraClienteChecklist, setSelectedIdEntregaObraClienteChecklist] = useState<number>();

    const [selectedEntregaObraClienteChecklist, setSelectedEntregaObraClienteChecklist] = useState<EntregaObraClienteChecklist>();
    const [selectedOcorrencia, setSelectedOcorrencia] = useState<InformacoesEntregaObraClienteModel>();
    const [selectedItemChecklist, setSelectedItemChecklist] = useState<VerificacaoChecklistModel>();

    const [selectedArquivoAux, setSelectedArquivoAux] = useState<EntregaObraClienteArquivoAuxModel>();
    const [selectedIdTermo, setSelectedIdTermo] = useState<number>();

    const [arquivoAuxLista, setArquivoAuxLista] = useState<EntregaObraClienteArquivoAuxModel[]>();
    const [termosLista, setTermosLista] = useState<EntregaObraClienteTermoModel[]>();
    const [ocorrenciasLista, setOcorrenciasLista] = useState<InformacoesEntregaObraClienteModel[]>();
    const [itensChecklistLista, setItensChecklistLista] = useState<VerificacaoChecklistModel[]>();

    const [ocorrenciaModal, setOcorrenciaModal] = useState(false);
    const [termoModal, setTermoModal] = useState(false);
    const [arquivoAuxModal, setArquivoAuxModal] = useState(false);

    const [pesquisaSatisfacaoModal, setPesquisaSatisfacaoModal] = useState(false);
    const [pesquisaSatisfacaoEditModal, setPesquisaSatisfacaoEditModal] = useState(false);
    const [pesquisaSatisfacaoDeleteModal, setPesquisaSatisfacaoDeleteModal] = useState(false);
    const [selectedIdPesquisaSatisfacao, setSelectedIdPesquisaSatisfacao] = useState<number>();

    const [entregaPesquisaSatisfacao, setEntregaPesquisaSatisfacao] = useState<EntregaObraPesquisaSatisfacao>();
    const [entregaPesquisaSatisfacaoLista, setEntregaPesquisaSatisfacaoLista] = useState<EntregaObraPesquisaSatisfacaoLista[]>();

    const [deleteOcorrenciaModal, setDeleteOcorrenciaModal] = useState(false);
    const [deleteTermoModal, setDeleteTermoModal] = useState(false);
    const [deleteArquivoAuxModal, setDeleteArquivoAuxModal] = useState(false);

    //Arquivo Viewer Modal
    const [imageViewerModalOpen, setImageViewerModalOpen] = useState(false);
    const [selectedImageFileName, setSelectedImageFileName] = useState<string>();
    const [selectedArquivoData, setSelectedArquivoData] = useState<string>();

    const [inspecaoItens] = hookForm.watch(['listaItensChecklist']);

    const lockInspecaoItens = useMemo(() => {
        return selectedEntregaObraClienteChecklist
            && selectedEntregaObraClienteChecklist.status !== 0
            && selectedEntregaObraClienteChecklist.status !== 2;
    }, [
        selectedEntregaObraClienteChecklist,
    ]);

    const changeHistory = useChangeHistory({
        getAllLogAlteracaoByParentUseCase,
        getAllLogAlteracaoUseCase,
        onSetError: e => pushErrorNotification("Erro", [e]),
    });

    const [reportViewerState, startReportViewerProcess] = useReportViewer();

    //#region CARREGAMENTOS
    const loadEntregaObraClienteChecklist = useCallback(async (idEntregaObraCliente: number) => {
        try {
            const response = await getEntregaObrasClienteByIdUseCase.execute(idEntregaObraCliente);
            if (response) {
                hookForm.setValue('idEntregaObraCliente', response.idEntregaObraCliente);
                hookForm.setValue('localVistoria', response.localVistoria ?? undefined);
                hookForm.setValue('idFuncionarioInsp', response.idFuncionarioInsp ?? undefined);
                hookForm.setValue('idFuncionarioReinsp', response.idFuncionarioReinsp ?? undefined);
                hookForm.setValue('dataInspecao', response.dataInspecao ? new Date(response.dataInspecao) : undefined);
                hookForm.setValue('dataReinsp', response.dataReinsp ? new Date(response.dataReinsp) : undefined);
                hookForm.setValue('status', response.status);
                hookForm.setValue('analiseVistoria', response.analiseVistoria ?? undefined);
            }
            setSelectedEntregaObraClienteChecklist(response);

        } catch (e: unknown) {
            setSelectedEntregaObraClienteChecklist(undefined);
            throw new Error('Falha ao buscar dados da entrega de obra do cliente!');
        }
    }, [
        hookForm, getEntregaObrasClienteByIdUseCase,
    ]);

    const loadItensChecklistEntregaObra = useCallback(async (idEntregaObraCliente: number) => {
        try {
            await getAllVerificacaoChecklistListaUseCase.execute(idEntregaObraCliente);
            const itens = getAllVerificacaoChecklistListaUseCase.items;

            hookForm.setValue('listaItensChecklist', itens.map(i => ({
                idVerificacaoCliente: i.idVerificacaoCliente,
                idEntregaObraCliente: i.idEntregaObraCliente,
                idChecklistEntrega: i.idChecklistEntrega,
                idItemChecklistEntrega: i.idItemChecklistEntrega,
                idChecklistEntregaAmbiente: i.idChecklistEntregaAmbiente,
                ordem: i.ordem,
                descricao: i.descricao,
                inspecao1: i.inspecao1,
                inspecao2: i.inspecao2,

                path: i.path,
            })));
            setItensChecklistLista(getAllVerificacaoChecklistListaUseCase.items);

        } catch (e: unknown) {
            setItensChecklistLista(undefined);
            hookForm.setValue('listaItensChecklist', []);
            throw new Error('Falha ao buscar dados da checklist de entrega de obra!');
        }
    }, [
        hookForm, getAllVerificacaoChecklistListaUseCase,
    ]);

    const loadListaOcorrencias = useCallback(async (idEntregaObraCliente: number) => {
        try {
            await getAllInformacoesEntregaObraClienteUseCase.execute(
                idEntregaObraCliente,
            );
            setOcorrenciasLista(getAllInformacoesEntregaObraClienteUseCase.items);
        } catch (e: unknown) {
            setOcorrenciasLista(undefined);
            throw new Error("Falha ao buscar dados da pagina!");
        }
    }, [getAllInformacoesEntregaObraClienteUseCase]);

    const loadListaTermos = useCallback(async (idEntregaObraCliente: number) => {
        try {
            await getAllEntregaObraClienteTermoUseCase.execute(
                idEntregaObraCliente,
            );
            setTermosLista(getAllEntregaObraClienteTermoUseCase.items);
        } catch (e: unknown) {
            setTermosLista(undefined);
            throw new Error("Falha ao buscar dados da pagina!");
        }
    }, [getAllEntregaObraClienteTermoUseCase]);

    const loadListaArquivosAux = useCallback(async (idEntregaObraCliente: number) => {
        try {
            await getAllEntregaObraClienteArquivoAuxUseCase.execute(
                idEntregaObraCliente,
            );
            setArquivoAuxLista(getAllEntregaObraClienteArquivoAuxUseCase.items);
        } catch (e: unknown) {
            setArquivoAuxLista(undefined);
            throw new Error("Falha ao buscar dados da pagina!");
        }
    }, [getAllEntregaObraClienteArquivoAuxUseCase]);


    const loadTermoDropDown = useCallback(async () => {
        try {
            const response = await getTermosDropDownUseCase.getTermosDropDown();
            setDdlTermos(response);
        } catch (e: unknown) {
            setDdlTermos(undefined);
            throw new Error("Falha ao buscar dados da pagina!");
        }
    }, [getTermosDropDownUseCase]);

    const loadPesquisaSatisfacaoDropDown = useCallback(async () => {
        try {
            const response = await getPesquisaSatisfacaoDropDownUseCase.getPesquisaSatisfacaoDropDown();
            setDdlPesquisaSatisfacao(response.map(item => ({
                id: item.idPesquisaSatisfacao,
                title: item.descricao,
            })));
        } catch (e: unknown) {
            setDdlPesquisaSatisfacao(undefined);
            throw new Error("Falha ao buscar dados da pagina!");
        }
    }, [getPesquisaSatisfacaoDropDownUseCase]);


    const loadEntregaPesquisaSatisfacaoLista = useCallback(async (idEntregaObraCliente: number) => {
        try {
            await getAllEntregaPesquisaSatisfacaoUseCase.execute(idEntregaObraCliente);
            setEntregaPesquisaSatisfacaoLista(getAllEntregaPesquisaSatisfacaoUseCase.items);

        } catch (e: unknown) {
            setEntregaPesquisaSatisfacaoLista(undefined);
            throw new Error('Falha ao buscar itens da pesquisa de satisfação dos clientes!');
        }
    }, [
        getAllEntregaPesquisaSatisfacaoUseCase,
    ]);

    const loadEntregaPesquisaSatisfacaoById = useCallback(async (idEntregaPesquisa: number) => {
        try {
            const result = await getEntregaPesquisaSatisfacaoByIdUseCase.execute(idEntregaPesquisa);
            setEntregaPesquisaSatisfacao(result);

        } catch (e: unknown) {
            setEntregaPesquisaSatisfacao(undefined);
            throw new Error('Falha ao buscar dados da pesquisa de satisfação dos clientes!');
        }
    }, [
        getEntregaPesquisaSatisfacaoByIdUseCase,
    ]);

    //#endregion




    //#region PAGE START

    usePageStartBootstrap(async () => {
        try {

            const params = new URLSearchParams(location.search);
            const locationIdEntregaObraCliente = params.get('id');

            const parsedId = Number(locationIdEntregaObraCliente);
            setSelectedIdEntregaObraClienteChecklist(parsedId);

            await loadEntregaObraClienteChecklist(parsedId);
            await loadItensChecklistEntregaObra(parsedId);
            await loadListaOcorrencias(parsedId);
            await loadListaTermos(parsedId);
            await loadListaArquivosAux(parsedId);
            await loadEntregaPesquisaSatisfacaoLista(parsedId);
            await loadPesquisaSatisfacaoDropDown();
            await loadTermoDropDown();
            // await Promise.allSettled([
            //     loadEntregaObraClienteChecklist(parsedId),
            //     loadItensChecklistEntregaObra(parsedId),
            //     loadListaOcorrencias(parsedId),
            //     loadListaTermos(parsedId),
            //     loadListaArquivosAux(parsedId),
            // ]);
        } catch (e: unknown) {
            setErrorMessage(processError(e, 'Falha ao buscar dados da página!')[0]);
        }
    });

    const handlePageBack = useCallback(() => {
        backOrNavigate(-1, { alternativeRoute: `/EntregaObrasCliente_lista` });
    }, [
        backOrNavigate,
    ]);

    const handleSubmit = useCallback(async (form: EntregaObraClienteChecklistCadastroForm) => {
        if (selectedEntregaObraClienteChecklist) {
            try {
                setSaving(true);
                setPageSaving(true);

                const filteredItensChecklist = form.listaItensChecklist ?? itensChecklistLista;

                await updateEntregaObrasClienteChecklistUseCase.execute(
                    selectedEntregaObraClienteChecklist.idEntregaObraCliente,
                    form.localVistoria,
                    form.idFuncionarioInsp,
                    form.idFuncionarioReinsp,
                    form.dataInspecao,
                    form.dataReinsp,
                    form.status,
                    form.analiseVistoria,

                    filteredItensChecklist,
                );

                await loadEntregaObraClienteChecklist(selectedEntregaObraClienteChecklist.idEntregaObraCliente);
                await loadItensChecklistEntregaObra(selectedEntregaObraClienteChecklist.idEntregaObraCliente);

                pushInfoNotification("Sucesso", "Informações salvas com sucesso!");
            } catch (e: unknown) {
                pushErrorNotification("Erro", processError(e, "Falha ao salvar inspeção obra!"));
            } finally {
                setSaving(false);
                setPageSaving(false);
            }
        }
    }, [
        itensChecklistLista,
        selectedEntregaObraClienteChecklist,
        updateEntregaObrasClienteChecklistUseCase,
        loadEntregaObraClienteChecklist,
        loadItensChecklistEntregaObra,
        pushErrorNotification,
        pushInfoNotification,
        setPageSaving,
    ]);


    //#region Ocorrencias Eventos
    const handleOcorrenciaModalOpenState = useCallback(async (idOcorrencia: number | null, idVerificacaoCliente: number | null, openState: boolean) => {
        if (openState) {
            //busca ocorrencia no banco de dados.
            if (idOcorrencia) {
                const ocorrencia = await getInformacoesEntregaObraClienteByIdUseCase.execute(idOcorrencia);
                setSelectedOcorrencia(ocorrencia);
            } else {
                setSelectedOcorrencia(undefined);
            }
            if (idVerificacaoCliente && inspecaoItens) {
                setSelectedItemChecklist(inspecaoItens.find(x => x.idVerificacaoCliente === idVerificacaoCliente));
            } else {
                setSelectedItemChecklist(undefined);
            }
        } else {
            setSelectedOcorrencia(undefined);
            setSelectedItemChecklist(undefined);
        }
        setOcorrenciaModal(openState);
    }, [
        getInformacoesEntregaObraClienteByIdUseCase,
        inspecaoItens
    ]);

    const handleInspecao1Change = useCallback((idVerificacaoCliente: number, value: string | number | null) => {
        const copiaInspecaoObraItens = [...hookForm.getValues().listaItensChecklist];
        const inspecaoObraItemIndex = copiaInspecaoObraItens.findIndex(x => x.idVerificacaoCliente === idVerificacaoCliente);

        if (inspecaoObraItemIndex >= 0) {
            copiaInspecaoObraItens[inspecaoObraItemIndex].inspecao1 = value?.toString() ?? '';
            copiaInspecaoObraItens[inspecaoObraItemIndex].inspecao2 = '';
        }

        hookForm.setValue('listaItensChecklist', copiaInspecaoObraItens);
    }, [
        hookForm,
    ]);

    const handleInspecao2Change = useCallback((idVerificacaoCliente: number, value: string | number | null) => {
        const copiaInspecaoObraItens = [...hookForm.getValues().listaItensChecklist];
        const inspecaoObraItemIndex = copiaInspecaoObraItens.findIndex(x => x.idVerificacaoCliente === idVerificacaoCliente);

        if (inspecaoObraItemIndex >= 0) {
            copiaInspecaoObraItens[inspecaoObraItemIndex].inspecao2 = value?.toString() ?? '';
        }

        hookForm.setValue('listaItensChecklist', copiaInspecaoObraItens);
    }, [
        hookForm,
    ]);




    const handleClearInspecaoObraItem = useCallback((idVerificacaoCliente: number) => {
        const copiaInspecaoObraItens = [...hookForm.getValues().listaItensChecklist];
        const inspecaoObraItemIndex = copiaInspecaoObraItens.findIndex(x => x.idVerificacaoCliente === idVerificacaoCliente);

        if (inspecaoObraItemIndex >= 0) {
            copiaInspecaoObraItens[inspecaoObraItemIndex].inspecao1 = '';
            copiaInspecaoObraItens[inspecaoObraItemIndex].inspecao2 = '';
        }

        hookForm.setValue('listaItensChecklist', copiaInspecaoObraItens);
    }, [
        hookForm,
    ]);

    const handleOcorrenciaSubmit = useCallback(async (form: EntregaObraClienteOcorrenciaForm) => {
        if (selectedEntregaObraClienteChecklist) {
            try {
                setSaving(true);
                setPageSaving(true);
                if (selectedOcorrencia) {
                    await updateInformacoesEntregaObraClienteUseCase.execute(
                        selectedOcorrencia.idInformacoesEntregaObraCliente,
                        selectedOcorrencia.idEntregaObraCliente ?? selectedEntregaObraClienteChecklist.idEntregaObraCliente,
                        form.idVerificacaoChecklist ?? 0,
                        form.dataDescricao ?? undefined,
                        form.dataTratativa ?? undefined,
                        form.descricao ?? undefined,
                        form.tratativa ?? undefined,
                        form.inspecao ?? undefined,

                        form.descricaoArquivo ?? undefined,
                        form.arquivo ?? undefined,
                        form.limparArquivo ?? false,

                        form.descricaoArquivo2 ?? undefined,
                        form.arquivo2 ?? undefined,
                        form.limparArquivo2 ?? false
                    );
                } else {
                    await createInformacoesEntregaObraClienteUseCase.execute(
                        selectedEntregaObraClienteChecklist.idEntregaObraCliente,
                        form.idVerificacaoChecklist ?? 0,
                        form.dataDescricao ?? undefined,
                        form.dataTratativa ?? undefined,
                        form.descricao ?? undefined,
                        form.tratativa ?? undefined,
                        form.inspecao ?? undefined,

                        form.descricaoArquivo ?? undefined,
                        form.arquivo ?? undefined,

                        form.descricaoArquivo2 ?? undefined,
                        form.arquivo2 ?? undefined
                    );
                }
                await loadListaOcorrencias(selectedEntregaObraClienteChecklist.idEntregaObraCliente);
                setOcorrenciaModal(false);
                pushInfoNotification('Sucesso', 'Registro salvo com sucesso!');
            } catch (e: unknown) {
                pushErrorNotification("Erro", processError(e, "Falha ao salvar ocorrência!"));
            } finally {
                setSelectedOcorrencia(undefined);
                setPageSaving(false);
                setSaving(false);
            }
        }
    }, [
        selectedEntregaObraClienteChecklist,
        selectedOcorrencia,
        createInformacoesEntregaObraClienteUseCase,
        updateInformacoesEntregaObraClienteUseCase,
        loadListaOcorrencias,
        pushErrorNotification,
        pushInfoNotification,
        setPageSaving,
    ]);

    const handleDeleteOcorrenciaModalOpenState = useCallback((idOcorrencia: number | null, openState: boolean) => {
        if (openState) {
            if (idOcorrencia && ocorrenciasLista) {
                setSelectedOcorrencia(ocorrenciasLista.find(x => x.idInformacoesEntregaObraCliente === idOcorrencia));
            } else {
                setSelectedOcorrencia(undefined);
            }
        }
        setDeleteOcorrenciaModal(openState);
    }, [
        ocorrenciasLista,
    ]);

    const handleDeleteOcorrenciaSubmit = useCallback(async () => {
        if (selectedOcorrencia && selectedEntregaObraClienteChecklist) {
            try {
                setSaving(true);
                setPageSaving(true);

                await deleteInformacoesEntregaObraClienteUseCase.execute(
                    selectedOcorrencia.idInformacoesEntregaObraCliente
                );

                await loadListaOcorrencias(selectedEntregaObraClienteChecklist.idEntregaObraCliente);
                setDeleteOcorrenciaModal(false);

                pushInfoNotification('Sucesso', 'Registro excluido com sucesso!');
            } catch (e: unknown) {
                pushErrorNotification('Erro', processError(e, 'Falha ao excluir ocorrência!'));
            } finally {
                setSaving(false);
                setPageSaving(false);
            }
        }
    }, [
        selectedEntregaObraClienteChecklist,
        selectedOcorrencia,
        deleteInformacoesEntregaObraClienteUseCase,
        loadListaOcorrencias,
        pushErrorNotification,
        pushInfoNotification,
        setPageSaving,
    ]);


    const handleDeleteFileOcorrencia = useCallback((nroArquivo: number) => {
        if (selectedOcorrencia) {
            if (nroArquivo === 1) {
                setSelectedOcorrencia({
                    ...selectedOcorrencia,
                    arquivo: undefined,
                    nomeArquivo: undefined,
                });
            } else if (nroArquivo === 2) {
                setSelectedOcorrencia({
                    ...selectedOcorrencia,
                    arquivo2: undefined,
                    nomeArquivo2: undefined,
                });
            }
        }
    }, [selectedOcorrencia]);

    const handleDownloadArquivoOcorrencia = useCallback(async (idInformacoesEntregaObraCliente: number, nrArquivo: number) => {
        try {
            setCustomLoading(true, "Carregando arquivo...");
            const ocorrencia = ocorrenciasLista?.find(arquivo =>
                arquivo.idInformacoesEntregaObraCliente === idInformacoesEntregaObraCliente);
            const nomeArquivo = (nrArquivo === 2 ? ocorrencia?.nomeArquivo2 : ocorrencia?.nomeArquivo) ?? 'arquivo';

            const blob = await downloadInfoEntregaObraClienteArquivoByIdUseCase
                .downloadInfoEntregaObraClienteArquivoById(idInformacoesEntregaObraCliente, nomeArquivo, nrArquivo, false);
            const base64 = await uploadFileToBase64StringValid(new File([blob], nomeArquivo, { type: blob.type }));

            setSelectedImageFileName(nomeArquivo);
            setSelectedArquivoData(base64);
            setImageViewerModalOpen(true);
        } catch (e: unknown) {
            pushErrorNotification("Erro", processError(e, "Falha ao baixar arquivo!"));
        } finally {
            setCustomLoading(false);
        }
    }, [
        downloadInfoEntregaObraClienteArquivoByIdUseCase,
        ocorrenciasLista,
        setCustomLoading,
        pushErrorNotification,
    ]);


    //#endregion





    //#region  Termos Eventos
    const handleTermosModalOpenState = useCallback((openState: boolean) => {
        setTermoModal(openState);
    }, [
    ]);

    const handleTermosSubmit = useCallback(async (form: EntregaObraClienteTermoForm) => {
        if (selectedEntregaObraClienteChecklist) {
            try {
                setSaving(true);

                await createEntregaObraClienteTermoUseCase.execute(
                    form.idEntregaObraCliente ?? selectedEntregaObraClienteChecklist.idEntregaObraCliente,
                    form.idsTermo,
                );

                await loadListaTermos(selectedEntregaObraClienteChecklist.idEntregaObraCliente);
                setTermoModal(false);
                pushInfoNotification('Sucesso', 'Registro salvo com sucesso!');
            } catch (e: unknown) {
                pushErrorNotification('Erro', processError(e, 'Falha ao criar termo!'));
            } finally {
                setSaving(false);
            }
        }
    }, [
        selectedEntregaObraClienteChecklist,
        createEntregaObraClienteTermoUseCase,
        loadListaTermos,
        pushErrorNotification,
        pushInfoNotification,
    ]);


    const handleDeleteTermoModalOpenState = useCallback((idTermo: number | null, openState: boolean) => {
        if (openState) {
            if (idTermo) {
                setSelectedIdTermo(idTermo);
            } else {
                setSelectedIdTermo(undefined);
            }
        }
        setDeleteTermoModal(openState);
    }, []);


    const handleDeleteTermoSubmit = useCallback(async () => {
        if (selectedIdTermo && selectedEntregaObraClienteChecklist) {
            try {
                setSaving(true);
                await deleteEntregaObraClienteTermoUseCase.execute(
                    selectedIdTermo
                );

                await loadListaTermos(selectedEntregaObraClienteChecklist.idEntregaObraCliente);

                setDeleteTermoModal(false);

                pushInfoNotification('Sucesso', 'Registro excluido com sucesso!');
            } catch (e: unknown) {
                pushErrorNotification('Erro', processError(e, 'Falha ao excluir termo !'));
            } finally {
                setSaving(false);
            }
        }
    }, [
        selectedEntregaObraClienteChecklist,
        selectedIdTermo,
        deleteEntregaObraClienteTermoUseCase,
        loadListaTermos,
        pushErrorNotification,
        pushInfoNotification,
    ]);

    //#endregion





    //#region PESQUISA SATISFAÇÃO

    const handlePesquisaSatisfacaoModalOpenState = useCallback((open: boolean) => {
        setPesquisaSatisfacaoModal(open);
    }, [
    ]);

    const handlePesquisaSatisfacaoEditarOpenState = useCallback(async (idEntregaPesquisa: number | null, openState: boolean) => {
        try {
            setPesquisaSatisfacaoEditModal(openState);
            if (openState) {
                setLoading(true);
                if (idEntregaPesquisa) {
                    await loadEntregaPesquisaSatisfacaoById(idEntregaPesquisa);
                } else {
                    setEntregaPesquisaSatisfacao(undefined);
                }
            }
        } catch (e: unknown) {
            pushErrorNotification('Erro', processError(e, "Falha ao carregar itens da pesquisa de satisfação!"));
        } finally {
            setLoading(false);
        }
    }, [
        loadEntregaPesquisaSatisfacaoById,
        pushErrorNotification,
    ]);

    const handlePesquisaSatisfacaoDeleteOpenState = useCallback((idEntregaPesquisa: number | null, open: boolean) => {
        if (open) {
            if (idEntregaPesquisa) {
                setSelectedIdPesquisaSatisfacao(idEntregaPesquisa);
            } else {
                setSelectedIdPesquisaSatisfacao(undefined);
            }
        }
        setPesquisaSatisfacaoDeleteModal(open);
    }, [
    ]);

    const handlePesquisaSatisfacaoDeleteSubmit = useCallback(async () => {
        if (selectedIdPesquisaSatisfacao) {
            try {
                setSaving(true);

                await deleteEntregaPesquisaSatisfacaoUseCase.execute(selectedIdPesquisaSatisfacao);

                pushInfoNotification('Sucesso', 'Registro excluído com sucesso!');

                if (!selectedIdEntregaObraClienteChecklist) {
                    pushErrorNotification('Erro', 'Id da entrega de obra cliente não encontrado para recarregar lista de pesquisas de satisfação!');
                    return;
                }

                await loadEntregaPesquisaSatisfacaoLista(selectedIdEntregaObraClienteChecklist!);
                setSelectedIdPesquisaSatisfacao(undefined);
                setPesquisaSatisfacaoDeleteModal(false);
            } catch (e: unknown) {
                pushErrorNotification('Erro', processError(e, "Falha ao excluir pesquisa de satisfação!"));
            } finally {
                setSaving(false);
            }
        }
    }, [
        selectedIdEntregaObraClienteChecklist,
        selectedIdPesquisaSatisfacao,
        deleteEntregaPesquisaSatisfacaoUseCase,
        pushInfoNotification,
        loadEntregaPesquisaSatisfacaoLista,
        pushErrorNotification,
    ]);


    const handlePesquisaSatisfacaoSubmit = useCallback(async (form: EntregaPesquisaSatisfacaoForm) => {
        try {
            setSaving(true);
            if (!selectedIdEntregaObraClienteChecklist) {
                pushErrorNotification('Erro', 'Id da entrega de obra cliente não encontrado para criar pesquisa de satisfação!');
                return;
            }

            const itensFormatados = form.itens?.map(item => ({
                ...item,
                descricao: item.descricao ?? undefined,
                nota: item.nota ?? undefined,
            })) ?? undefined;

            await updateEntregaPesquisaSatisfacaoUseCase.execute(
                form.idEntregaPesquisa ?? selectedIdPesquisaSatisfacao,
                form.status ?? 0,
                form.idEntregaObraCliente ?? 0,
                form.data ?? undefined,
                form.observacao ?? undefined,
                itensFormatados,
            );
            pushInfoNotification('Sucesso', 'Registro criado com sucesso!');
            await loadEntregaPesquisaSatisfacaoLista(selectedIdEntregaObraClienteChecklist);
            setPesquisaSatisfacaoEditModal(false);
        } catch (e: unknown) {
            pushErrorNotification('Erro', processError(e, "Falha ao salvar pesquisa de satisfação!"));
        } finally {
            setSaving(false);
        }
    }, [
        selectedIdEntregaObraClienteChecklist,
        selectedIdPesquisaSatisfacao,
        updateEntregaPesquisaSatisfacaoUseCase,
        loadEntregaPesquisaSatisfacaoLista,
        pushInfoNotification,
        pushErrorNotification,
    ]);

    const handlePesquisaSatisfacaoListaSubmit = useCallback(async (form: PesquisaSatisfacaoForm) => {

        try {
            setSaving(true);
            if (!selectedIdEntregaObraClienteChecklist) {
                pushErrorNotification('Erro', 'Id da entrega de obra cliente não encontrado para criar pesquisa de satisfação!');
                return;
            }

            if (!form.pesquisas || form.pesquisas.length === 0) {
                pushErrorNotification('Erro', 'Nenhum item de pesquisa de satisfação selecionado para criar!');
                return;
            }

            await Promise.all(form.pesquisas.map(e =>
                createEntregaPesquisaSatisfacaoUseCase.execute(
                    selectedIdEntregaObraClienteChecklist,
                    e,
                )
            ));

            pushInfoNotification('Sucesso', 'Registro criado com sucesso!');
            setPesquisaSatisfacaoModal(false);
            await loadEntregaPesquisaSatisfacaoLista(selectedIdEntregaObraClienteChecklist!);
        } catch (e: unknown) {
            pushErrorNotification('Erro', processError(e, "Falha ao salvar pesquisa de satisfação!"));
        } finally {
            setSaving(false);
        }
    }, [
        selectedIdEntregaObraClienteChecklist,
        createEntregaPesquisaSatisfacaoUseCase,
        loadEntregaPesquisaSatisfacaoLista,
        pushInfoNotification,
        pushErrorNotification,
    ]);

    //#endregion





    //#region ArquivosAuxiliares

    const handleArquivoAuxModalOpenState = useCallback(async (idEntregaObraClienteArquivoAux: number | null, openState: boolean) => {
        setArquivoAuxModal(openState);
        if (openState && idEntregaObraClienteArquivoAux) {
            const arquivoAux = await getEntregaObraClienteArquivoAuxByIdUseCase.execute(idEntregaObraClienteArquivoAux);
            setSelectedArquivoAux(arquivoAux);
        } else {
            setSelectedArquivoAux(undefined);
        }
    }, [
        getEntregaObraClienteArquivoAuxByIdUseCase,
    ]);

    const handleSubmitNewArquivoAux = useCallback(async (form: EntregaObraClienteArquivoAuxForm) => {
        try {
            setSaving(true);
            if (!selectedEntregaObraClienteChecklist) {
                pushErrorNotification("Atenção", "Selecione uma obra de entrega para adicionar um arquivo!", { isAutoFinish: true });
                return;
            }

            if (selectedArquivoAux) {
                await updateEntregaObraClienteArquivoAuxUseCase.execute(
                    form.idEntregaObraClienteArquivoAux ?? 0,
                    selectedEntregaObraClienteChecklist.idEntregaObraCliente ?? 0,
                    form.descricao,
                    form.arquivo ?? undefined,
                    form.limparArquivo
                );
            } else {
                await createEntregaObraClienteArquivoAuxUseCase.execute(
                    selectedEntregaObraClienteChecklist.idEntregaObraCliente ?? 0,
                    form.descricao,
                    form.arquivo ?? undefined,
                );
            }

            await loadListaArquivosAux(selectedEntregaObraClienteChecklist.idEntregaObraCliente);
            pushInfoNotification("Sucesso", "Arquivo criado com sucesso!", { isAutoFinish: true });

        } catch (e: unknown) {
            pushErrorNotification("Erro", processError(e, "Falha ao salvar item do Checklist de entrega!"));
        } finally {
            setSelectedArquivoAux(undefined);
            setArquivoAuxModal(false);
            setSaving(false);
        }
    }, [
        selectedEntregaObraClienteChecklist,
        selectedArquivoAux,
        createEntregaObraClienteArquivoAuxUseCase,
        updateEntregaObraClienteArquivoAuxUseCase,
        loadListaArquivosAux,
        pushErrorNotification,
        pushInfoNotification
    ]);

    const handleDownloadArquivoAux = useCallback(async (idEntregaObraClienteArquivoAux: number) => {
        try {
            if (idEntregaObraClienteArquivoAux) {
                const nomeArquivo = arquivoAuxLista?.find(arquivo =>
                    arquivo.idEntregaObraClienteArquivoAux === idEntregaObraClienteArquivoAux)?.nome ?? 'arquivo';
                await downloadEntregaObraClienteArquivoAuxByIdUseCase
                    .downloadEntregaObraClienteArquivoAuxById(idEntregaObraClienteArquivoAux, nomeArquivo);
                return;
            }
        } catch (e: unknown) {
            pushErrorNotification("Erro", processError(e, "Falha ao baixar arquivo!"));
        } finally {
            setCustomLoading(false);
        }
    }, [
        downloadEntregaObraClienteArquivoAuxByIdUseCase,
        arquivoAuxLista,
        setCustomLoading,
        pushErrorNotification,
    ]);

    const handleImageViewerModalOpenState = useCallback((openState: boolean) => {
        setImageViewerModalOpen(openState);
        if (!openState) {
            setSelectedImageFileName(undefined);
            setSelectedArquivoData(undefined);
        }
    }, []);

    const handleDeleteArquivoAuxOpenState = useCallback(async (idEntregaObraClienteArquivoAux: number | null, openState: boolean) => {
        setDeleteArquivoAuxModal(openState);
        if (openState && idEntregaObraClienteArquivoAux) {
            const arquivoAux = await getEntregaObraClienteArquivoAuxByIdUseCase.execute(idEntregaObraClienteArquivoAux);
            setSelectedArquivoAux(arquivoAux);
        } else {
            setSelectedArquivoAux(undefined);
        }
    }, [
        getEntregaObraClienteArquivoAuxByIdUseCase,
    ]);

    const handleSubmitDeleteArquivoAux = useCallback(async () => {
        try {
            if (!selectedArquivoAux || !selectedEntregaObraClienteChecklist) {
                pushInfoNotification("Atenção", "Nenhum arquivo selecionado!", { isAutoFinish: true });
                return;
            }

            setSaving(true);
            await deleteEntregaObraClienteArquivoAuxUseCase.execute(selectedArquivoAux.idEntregaObraClienteArquivoAux);

            await loadListaArquivosAux(selectedEntregaObraClienteChecklist?.idEntregaObraCliente);
            setDeleteArquivoAuxModal(false);
            pushInfoNotification("Sucesso", "Arquivo deletado com sucesso!", { isAutoFinish: true });

        } catch (e: unknown) {
            pushErrorNotification("Erro", processError(e, "Falha ao deletar arquivo!"));
        } finally {
            setSaving(false);
        }
    }, [
        selectedArquivoAux,
        selectedEntregaObraClienteChecklist,
        deleteEntregaObraClienteArquivoAuxUseCase,
        loadListaArquivosAux,
        pushErrorNotification,
        pushInfoNotification
    ]);


    //#endregion




    //#region RELATÓRIOS
    const handleReportSimple = useCallback(async () => {
        try {
            setLoading(true);
            if (!selectedIdEntregaObraClienteChecklist) {
                pushWarnNotification("Atenção", "Selecione uma vistoria!", { isAutoFinish: true });
                return;
            }

            await startReportViewerProcess({
                fetchCallback: async (requiredMimeType) =>
                    await getReportEntregaObraClienteSimplesUseCase.execute(
                        requiredMimeType,
                        selectedIdEntregaObraClienteChecklist,
                    ),
            });

        } catch (e: unknown) {
            pushErrorNotification("Erro", processError(e, "Falha ao gerar relatório!"));
        } finally {
            setLoading(false);
        }

    }, [
        selectedIdEntregaObraClienteChecklist,
        getReportEntregaObraClienteSimplesUseCase,
        startReportViewerProcess,
        pushWarnNotification,
        pushErrorNotification,
    ]);


    const handleReportTermo = useCallback(async (idEntregaObraClienteTermo: number) => {
        try {
            setLoading(true);
            await startReportViewerProcess({
                fetchCallback: async (requiredMimeType) =>
                    await getReportEntregaObraClienteTermoUseCase.execute(
                        requiredMimeType,
                        idEntregaObraClienteTermo,
                    ),
            });

        } catch (e: unknown) {
            pushErrorNotification("Erro", processError(e, "Falha ao gerar relatório!"));
        } finally {
            setLoading(false);
        }
    }, [
        getReportEntregaObraClienteTermoUseCase,
        startReportViewerProcess,
        pushErrorNotification
    ]);

    //#endregion

    const handleOpenChangeHistory = useCallback((
        idTabela: number | null,
        tipoTabela: LogTipoTabela | null,
    ) => {
        if (idTabela && tipoTabela) {
            changeHistory.handleOpenChangeHistory(idTabela, tipoTabela, false);
        } else {
            if (selectedEntregaObraClienteChecklist) {
                changeHistory.handleOpenChangeHistory(selectedEntregaObraClienteChecklist.idEntregaObraCliente,
                    LogTipoTabela.ENTREGA_OBRA_CLIENTE, true);
            }
        }
    }, [
        selectedEntregaObraClienteChecklist,
        changeHistory,
    ]);


    return {
        hookForm,
        loading,
        saving,
        termoModal,
        arquivoAuxModal,
        deleteTermoModal,
        deleteArquivoAuxModal,
        errorMessage,
        ocorrenciaModal,
        deleteOcorrenciaModal,
        selectedOcorrencia: selectedOcorrencia ?? null,
        selectedItemChecklist: selectedItemChecklist ?? null,
        ddlTermos: ddlTermos ?? [],
        termosLista: termosLista ?? [],
        ocorrenciasLista: ocorrenciasLista ?? [],
        arquivoAuxLista: arquivoAuxLista ?? [],
        ddlPesquisaSatisfacao: ddlPesquisaSatisfacao ?? [],
        changeHistory,
        selectedEntregaObraClienteChecklist,
        itensChecklistListaBase: itensChecklistLista ?? [],
        itensChecklistLista: inspecaoItens,
        lockInspecaoItens,
        selectedArquivoAux,
        selectedIdEntregaObraClienteChecklist,
        pesquisaSatisfacaoModal,
        pesquisaSatisfacaoDeleteModal,
        pesquisaSatisfacaoEditModal,
        entregaPesquisaSatisfacaoLista: entregaPesquisaSatisfacaoLista ?? [],
        entregaPesquisaSatisfacao,
        reportViewerState,

        imageViewerModalOpen,
        selectedArquivoData,
        selectedImageFileName,
        handleImageViewerModalOpenState,
        handlePesquisaSatisfacaoModalOpenState,
        handlePesquisaSatisfacaoEditarOpenState,
        handlePesquisaSatisfacaoDeleteOpenState,
        handlePesquisaSatisfacaoDeleteSubmit,
        handlePesquisaSatisfacaoSubmit,
        handlePesquisaSatisfacaoListaSubmit,

        handleDownloadArquivoOcorrencia,
        handleDownloadArquivoAux,
        handleReportSimple,
        handleReportTermo,
        handleDeleteFileOcorrencia,
        handlePageBack,
        handleTermosModalOpenState,
        handleTermosSubmit,
        handleDeleteTermoModalOpenState,
        handleDeleteTermoSubmit,
        handleArquivoAuxModalOpenState,
        handleSubmitNewArquivoAux,
        handleDeleteArquivoAuxOpenState,
        handleSubmitDeleteArquivoAux,
        handleSubmit: hookForm.handleSubmit(handleSubmit),
        handleOcorrenciaModalOpenState,
        handleInspecao1Change,
        handleInspecao2Change,
        handleClearInspecaoObraItem,
        handleOcorrenciaSubmit,
        handleDeleteOcorrenciaModalOpenState,
        handleDeleteOcorrenciaSubmit,
        handleOpenChangeHistory,

    };
}